/** playlist: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "dragLength": "Drag to change how long it plays",
  "chipDefault": "Default",
  "orCustom": "or",
  "fitHint_fit": "Fit: the whole picture shows; bars where the shapes differ.",
  "fitHint_fill": "Fill: covers the screen; edges are cropped.",
  "fitHint_stretch": "Stretch: covers the screen; the picture is stretched to it.",
  "removeItem": "Remove from playlist",
  "removeNamed": "Remove “{name}” from the playlist",
  "removedItem": "Removed “{name}”",
  "undo": "Undo",
  "dragPlayhead": "Drag to move through the preview",
  "newPlaylist": "New Playlist",
  "newAudioPlaylist": "New Audio Playlist",
  "orderManual": "in the order below",
  "orderByType": "grouped by type (campaigns, videos, images, apps)",
  "orderShuffle": "in a new random order each time",
  "hintAudio": "Files play one after another {order}, and repeat.",
  "hintAll": "Each time the player’s loop reaches this playlist, every item plays, {order}.",
  "hintCycle": "Each time the player’s loop reaches this playlist, the next item plays ({order}); next time it carries on from there. | Each time the player’s loop reaches this playlist, the next {n} items play ({order}); next time it carries on from there.",
  "fit": "Fit",
  "fill": "Fill",
  "stretch": "Stretch",
  "tImage": "Image",
  "tVideo": "Video",
  "tApp": "App",
  "tCampaign": "Campaign",
  "tAudio": "Audio",
  "tPdf": "PDF",
  "pImage": "Images",
  "pVideo": "Videos",
  "pApp": "Apps",
  "pCampaign": "Campaigns",
  "pAudio": "Audio",
  "pPdf": "PDFs",
  "all": "All",
  "savedToast": "Playlist saved · updating {n} player | Playlist saved · updating {n} players",
  "playlistWord": "Playlist",
  "nSelected": "{n} selected",
  "addN": "Add {n} →",
  "nItems": "{n} item | {n} items",
  "hidePanel": "Hide Content Panel",
  "showPanel": "Show Content Panel",
  "reorderAria": "Reorder {name} (position {n}); Alt+Arrow keys move it",
  "pauseX": "Pause {name}",
  "resumeX": "Resume {name}",
  "displayFor": "Display settings for {name}",
  "onePass": "· one pass",
  "publishedOn": "▶ Published on {n} player | ▶ Published on {n} players",
  "cycleNote": "On players, Cycle shows {n} per pass.",
  "orderNoteShuffle": "On players the order is shuffled.",
  "orderNoteByType": "On players the order is by type.",
  "fullScreen": "· full screen",
  "pausedNotShown": "· {n} paused (not shown)",
  "defaultOf": "Default ({v})",
  "ownLength": ", own length",
  "unavailable": "Unavailable item",
  "trNone": "None",
  "trFade": "Fade",
  "trSlide": "Slide",
  "trFlip": "Flip",
  "notPublishedToast": "Playlist saved · not published to any player yet",
  "leaveQ": "You have unsaved changes. Leave without saving?",
  "changeTypeQ": "Changing the type removes the items already added. Continue?",
  "back": "Back to Content",
  "backPrev": "Back",
  "playlistName": "Playlist Name",
  "unsaved": "Unsaved changes",
  "restrictAll": "Restrict when it plays, on all players",
  "restrictedAll": "Restricted on all players — change",
  "restrictionLocked": "🔒 Restriction",
  "restriction": "Restriction",
  "saveTitle": "Save (Ctrl+S)",
  "create": "Create Playlist",
  "saving": "Saving…",
  "savePublish": "Save & Publish",
  "publish": "Publish",
  "loading": "Loading…",
  "settings": "Playlist settings",
  "playlistType": "Playlist Type",
  "visual": "Visual",
  "audioHint": "Audio files played in order and looped as a campaign’s Audio Track. Each file plays its full length.",
  "defaultDuration": "Default Media Duration",
  "seconds": "seconds",
  "durationHint": "Images and apps. Videos and campaigns play their own length.",
  "defaultTransition": "Default Transition",
  "transitionMsLabel": "Transition length in milliseconds",
  "ms": "ms",
  "betweenItems": "Between items, on the player.",
  "defaultFit": "Default Object fit",
  "fitLong": "Fit (whole item, bars if needed)",
  "fillLong": "Fill (cover, crops edges)",
  "stretchLong": "Stretch (fill exactly)",
  "playbackMode": "Playback Mode",
  "playAll": "Play All Items",
  "cycle": "Cycle Items",
  "perPass": "Items per pass",
  "playbackOrder": "Playback Order",
  "manual": "Manual",
  "byType": "By Type",
  "shuffle": "Shuffle",
  "contentTitle": "Content",
  "dragHint": "Drag, double-click, or tick and Add",
  "search": "Search",
  "searchContent": "Search content",
  "type": "Type",
  "noAudioFiles": "No audio files yet. Upload MP3, M4A, WAV, OGG or FLAC files in Content.",
  "nothing": "Nothing matches.",
  "playlistContent": "Playlist Content",
  "selectAll": "Select all",
  "pauseBtn": "⏸ Pause",
  "resumeBtn": "▶ Resume",
  "removeBtn": "✕ Remove",
  "empty": "This playlist is empty",
  "emptyHint": "Drag items from the Content panel, double-click them, or tick them and press Add.",
  "dragReorder": "Drag to reorder",
  "paused": "⏸ Paused",
  "defaultTip": "Default",
  "override": "Override",
  "defaultSmall": "default",
  "pause": "Pause",
  "resume": "Resume",
  "displaySettings": "Display settings",
  "removeFrom": "Remove from playlist",
  "notPublished": "Not published to any player yet",
  "differs": "• = differs from the playlist default",
  "preview": "Preview",
  "addToPreview": "Add content to preview the playlist",
  "playhead": "Playhead",
  "pausePreview": "Pause preview",
  "playPreview": "Play preview",
  "previewHint": "One pass in list order, with each item's transition; video plays without sound.",
  "timeline": "Timeline",
  "timelineHint": "Click to jump · double-click for display settings · drag to reorder",
  "zoom": "Zoom",
  "viewAs": "Show as",
  "viewTimeline": "Timeline",
  "viewList": "List",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "pausedWord": "Paused",
  "thenNext": "⟳ Then the next item in the loop",
  "dragHere": "Drag content here",
  "howDisplay": "How should this content be displayed?",
  "duration": "Duration",
  "durationSeconds": "Duration in seconds",
  "transition": "Transition",
  "howEnters": "How this item enters.",
  "objectFit": "Object fit",
  "appliedOnSave": "Applied when you save the playlist.",
  "cancel": "Cancel",
  "ok": "OK",
  "save": "Save",
  "saved": "Saved",
  "selectX": "Select {name}",
  "removeX": "Remove {name}"
};
const ar: typeof en = {
  "dragLength": "اسحب لتغيير مدة العرض",
  "chipDefault": "الافتراضي",
  "orCustom": "أو",
  "fitHint_fit": "احتواء: تظهر الصورة كاملة مع أشرطة حيث تختلف الأبعاد.",
  "fitHint_fill": "ملء: تغطي الشاشة وتُقص الحواف.",
  "fitHint_stretch": "تمديد: تغطي الشاشة وتُمدّد الصورة.",
  "removeItem": "إزالة من قائمة التشغيل",
  "removeNamed": "إزالة «{name}» من قائمة التشغيل",
  "removedItem": "تمت إزالة «{name}»",
  "undo": "تراجع",
  "dragPlayhead": "اسحب للتنقل في المعاينة",
  "newPlaylist": "قائمة تشغيل جديدة",
  "newAudioPlaylist": "قائمة تشغيل صوتية جديدة",
  "orderManual": "بالترتيب أدناه",
  "orderByType": "مجمّعة حسب النوع (حملات، فيديوهات، صور، تطبيقات)",
  "orderShuffle": "بترتيب عشوائي جديد في كل مرة",
  "hintAudio": "تُشغَّل الملفات واحدًا تلو الآخر {order}، وتتكرر.",
  "hintAll": "في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، تُعرض كل العناصر {order}.",
  "hintCycle": "في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، لا يُعرض شيء ({order}). | في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، يُعرض العنصر التالي ({order})؛ وفي المرة القادمة تكمل من حيث توقفت. | في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، يُعرض العنصران التاليان ({order})؛ وفي المرة القادمة تكمل من حيث توقفت. | في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، تُعرض العناصر الـ{n} التالية ({order})؛ وفي المرة القادمة تكمل من حيث توقفت. | في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، يُعرض {n} عنصرًا تاليًا ({order})؛ وفي المرة القادمة تكمل من حيث توقفت. | في كل مرة تصل فيها حلقة المشغل إلى قائمة التشغيل هذه، يُعرض {n} عنصر تالٍ ({order})؛ وفي المرة القادمة تكمل من حيث توقفت.",
  "fit": "احتواء",
  "fill": "ملء",
  "stretch": "تمديد",
  "tImage": "صورة",
  "tVideo": "فيديو",
  "tApp": "تطبيق",
  "tCampaign": "حملة",
  "tAudio": "صوت",
  "tPdf": "PDF",
  "pImage": "الصور",
  "pVideo": "الفيديوهات",
  "pApp": "التطبيقات",
  "pCampaign": "الحملات",
  "pAudio": "الصوت",
  "pPdf": "ملفات PDF",
  "all": "الكل",
  "savedToast": "تم حفظ قائمة التشغيل · لا مشغلات للتحديث | تم حفظ قائمة التشغيل · يجري تحديث مشغل واحد | تم حفظ قائمة التشغيل · يجري تحديث مشغلين | تم حفظ قائمة التشغيل · يجري تحديث {n} مشغلات | تم حفظ قائمة التشغيل · يجري تحديث {n} مشغلًا | تم حفظ قائمة التشغيل · يجري تحديث {n} مشغل",
  "playlistWord": "قائمة التشغيل",
  "nSelected": "{n} محدد",
  "addN": "إضافة {n} ←",
  "nItems": "لا عناصر | عنصر واحد | عنصران | {n} عناصر | {n} عنصرًا | {n} عنصر",
  "hidePanel": "إخفاء لوحة المحتوى",
  "showPanel": "إظهار لوحة المحتوى",
  "reorderAria": "إعادة ترتيب {name} (الموضع {n})؛ مفاتيح Alt+الأسهم تحرّكه",
  "pauseX": "إيقاف {name} مؤقتًا",
  "resumeX": "استئناف {name}",
  "displayFor": "إعدادات العرض لـ {name}",
  "onePass": "· دورة واحدة",
  "publishedOn": "▶ غير منشورة | ▶ منشورة على مشغل واحد | ▶ منشورة على مشغلين | ▶ منشورة على {n} مشغلات | ▶ منشورة على {n} مشغلًا | ▶ منشورة على {n} مشغل",
  "cycleNote": "على المشغلات، يعرض التدوير {n} في كل دورة.",
  "orderNoteShuffle": "على المشغلات يكون الترتيب عشوائيًا.",
  "orderNoteByType": "على المشغلات يكون الترتيب حسب النوع.",
  "fullScreen": "· ملء الشاشة",
  "pausedNotShown": "· {n} متوقف مؤقتًا (غير معروض)",
  "defaultOf": "افتراضي ({v})",
  "ownLength": "، بطوله",
  "unavailable": "عنصر غير متاح",
  "trNone": "بلا",
  "trFade": "تلاشٍ",
  "trSlide": "انزلاق",
  "trFlip": "قلب",
  "notPublishedToast": "تم حفظ قائمة التشغيل · لم تُنشر على أي مشغل بعد",
  "leaveQ": "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "changeTypeQ": "تغيير النوع يزيل العناصر المضافة. متابعة؟",
  "back": "العودة إلى المحتوى",
  "backPrev": "رجوع",
  "playlistName": "اسم قائمة التشغيل",
  "unsaved": "تغييرات غير محفوظة",
  "restrictAll": "تقييد وقت التشغيل على كل المشغلات",
  "restrictedAll": "مقيّدة على كل المشغلات — تغيير",
  "restrictionLocked": "🔒 قيد",
  "restriction": "قيد",
  "saveTitle": "حفظ (Ctrl+S)",
  "create": "إنشاء قائمة التشغيل",
  "saving": "جارٍ الحفظ…",
  "savePublish": "حفظ ونشر",
  "publish": "نشر",
  "loading": "جارٍ التحميل…",
  "settings": "إعدادات قائمة التشغيل",
  "playlistType": "نوع قائمة التشغيل",
  "visual": "مرئية",
  "audioHint": "ملفات صوتية تُشغَّل بالترتيب وتتكرر كمسار صوتي للحملة. يُشغَّل كل ملف بطوله الكامل.",
  "defaultDuration": "مدة الوسائط الافتراضية",
  "seconds": "ثانية",
  "durationHint": "للصور والتطبيقات. تُعرض الفيديوهات والحملات بطولها.",
  "defaultTransition": "الانتقال الافتراضي",
  "transitionMsLabel": "طول الانتقال بالملّي ثانية",
  "ms": "ملّي ث",
  "betweenItems": "بين العناصر على المشغل.",
  "defaultFit": "ملاءمة العرض الافتراضية",
  "fitLong": "احتواء (العنصر كاملًا، مع أشرطة عند الحاجة)",
  "fillLong": "ملء (تغطية، مع قص الحواف)",
  "stretchLong": "تمديد (ملء تام)",
  "playbackMode": "وضع التشغيل",
  "playAll": "تشغيل كل العناصر",
  "cycle": "تدوير العناصر",
  "perPass": "العناصر في كل دورة",
  "playbackOrder": "ترتيب التشغيل",
  "manual": "يدوي",
  "byType": "حسب النوع",
  "shuffle": "عشوائي",
  "contentTitle": "المحتوى",
  "dragHint": "اسحب، أو انقر مرتين، أو حدّد ثم أضف",
  "search": "بحث",
  "searchContent": "البحث في المحتوى",
  "type": "النوع",
  "noAudioFiles": "لا توجد ملفات صوتية بعد. ارفع ملفات MP3 أو M4A أو WAV أو OGG أو FLAC في المحتوى.",
  "nothing": "لا توجد نتائج مطابقة.",
  "playlistContent": "محتوى قائمة التشغيل",
  "selectAll": "تحديد الكل",
  "pauseBtn": "⏸ إيقاف مؤقت",
  "resumeBtn": "▶ استئناف",
  "removeBtn": "✕ إزالة",
  "empty": "قائمة التشغيل هذه فارغة",
  "emptyHint": "اسحب عناصر من لوحة المحتوى، أو انقر عليها مرتين، أو حدّدها واضغط إضافة.",
  "dragReorder": "اسحب لإعادة الترتيب",
  "paused": "⏸ متوقف مؤقتًا",
  "defaultTip": "افتراضي",
  "override": "مخصص",
  "defaultSmall": "افتراضي",
  "pause": "إيقاف مؤقت",
  "resume": "استئناف",
  "displaySettings": "إعدادات العرض",
  "removeFrom": "إزالة من قائمة التشغيل",
  "notPublished": "لم تُنشر على أي مشغل بعد",
  "differs": "• = يختلف عن الإعداد الافتراضي لقائمة التشغيل",
  "preview": "معاينة",
  "addToPreview": "أضف محتوى لمعاينة قائمة التشغيل",
  "playhead": "مؤشر التشغيل",
  "pausePreview": "إيقاف المعاينة مؤقتًا",
  "playPreview": "تشغيل المعاينة",
  "previewHint": "دورة واحدة بترتيب القائمة مع انتقال كل عنصر؛ يُعرض الفيديو دون صوت.",
  "timeline": "المخطط الزمني",
  "timelineHint": "انقر للانتقال · انقر مرتين لإعدادات العرض · اسحب لإعادة الترتيب",
  "zoom": "تكبير",
  "viewAs": "العرض",
  "viewTimeline": "المخطط الزمني",
  "viewList": "قائمة",
  "moveUp": "تحريك {name} لأعلى",
  "moveDown": "تحريك {name} لأسفل",
  "pausedWord": "متوقف مؤقتًا",
  "thenNext": "⟳ ثم العنصر التالي في الحلقة",
  "dragHere": "اسحب المحتوى إلى هنا",
  "howDisplay": "كيف يجب عرض هذا المحتوى؟",
  "duration": "المدة",
  "durationSeconds": "المدة بالثواني",
  "transition": "الانتقال",
  "howEnters": "طريقة دخول هذا العنصر.",
  "objectFit": "ملاءمة العرض",
  "appliedOnSave": "تُطبَّق عند حفظ قائمة التشغيل.",
  "cancel": "إلغاء",
  "ok": "موافق",
  "save": "حفظ",
  "saved": "محفوظ",
  "selectX": "تحديد {name}",
  "removeX": "إزالة {name}"
};
export default { en, ar };
